import { DEFAULT_LOCALE } from "./localization.constants";
import { useLocale } from "./use-locale";

const localeMap: { [wacLocale: string]: string } = {
    [DEFAULT_LOCALE]: "",
    de: "de",
    es: "es",
    fr: "fr",
    it: "it",
    ko: "ko",
    nl: "nl",
    ja: "ja",
    pl: "pl",
    br: "br",
    ru: "ru",
    zh: "zh",
    ro: "ro",
    cs: "cs",
    hu: "hu",
    fi: "fi",
    xx: "xx",
    zz: "zz"
};

export function useLocalizedPartnerdirectory() {
    const locale = useLocale();

    return `//partnerdirectory.atlassian.com/${
        localeMap[locale] || localeMap[DEFAULT_LOCALE]
    }`;
}

export function isPartnerDirectoryUrl(url: string): boolean {
    return url.includes("//partnerdirectory.atlassian.com/");
}

export function useLocalizedPartnerDirectoryHref(url: string): string {
    const localizedPartnerDirectoryUrl = useLocalizedPartnerdirectory();
    const locale = useLocale();

    if (isPartnerDirectoryUrl(url) && locale !== DEFAULT_LOCALE) {
        return url.replace(
            "//partnerdirectory.atlassian.com/",
            `${localizedPartnerDirectoryUrl}/`
        );
    }
    return url;
}
